import * as Models from "./Models/index.js";
/** CoStar.Api.Ccms.DataProvider.ProviderType */
export var ProviderType;
(function (ProviderType) {
    ProviderType[ProviderType["Geography"] = 0] = "Geography";
    ProviderType[ProviderType["IndependentOwner"] = 1] = "IndependentOwner";
})(ProviderType || (ProviderType = {}));
/** CoStar.Api.Ccms.DataProvider.TextEntityType */
export var TextEntityType;
(function (TextEntityType) {
    TextEntityType[TextEntityType["Submarket"] = 0] = "Submarket";
    TextEntityType[TextEntityType["Cluster"] = 1] = "Cluster";
    TextEntityType[TextEntityType["Cbsa"] = 2] = "Cbsa";
    TextEntityType[TextEntityType["Market"] = 3] = "Market";
    TextEntityType[TextEntityType["NationalMajor"] = 7] = "NationalMajor";
    TextEntityType[TextEntityType["College"] = 20] = "College";
    TextEntityType[TextEntityType["NationalCollege"] = 27] = "NationalCollege";
    TextEntityType[TextEntityType["ProductMarket"] = 31] = "ProductMarket";
    TextEntityType[TextEntityType["Listing"] = 100001] = "Listing";
    TextEntityType[TextEntityType["Location"] = 100002] = "Location";
})(TextEntityType || (TextEntityType = {}));
/** CoStar.Api.Ccms.DataProvider.RelativeTimePeriodType */
export var RelativeTimePeriodType;
(function (RelativeTimePeriodType) {
    RelativeTimePeriodType[RelativeTimePeriodType["NotSpecified"] = 0] = "NotSpecified";
    RelativeTimePeriodType[RelativeTimePeriodType["CurrentDate"] = 1] = "CurrentDate";
    RelativeTimePeriodType[RelativeTimePeriodType["CurrentQtr"] = 2] = "CurrentQtr";
    RelativeTimePeriodType[RelativeTimePeriodType["CurrentYear"] = 3] = "CurrentYear";
    RelativeTimePeriodType[RelativeTimePeriodType["PreviousQtr"] = 4] = "PreviousQtr";
    RelativeTimePeriodType[RelativeTimePeriodType["PreviousYear"] = 5] = "PreviousYear";
    RelativeTimePeriodType[RelativeTimePeriodType["TwoQtrAgo"] = 6] = "TwoQtrAgo";
    RelativeTimePeriodType[RelativeTimePeriodType["FourQtrAgo"] = 7] = "FourQtrAgo";
    RelativeTimePeriodType[RelativeTimePeriodType["TwoYearAgo"] = 8] = "TwoYearAgo";
    RelativeTimePeriodType[RelativeTimePeriodType["ThreeYearAgo"] = 9] = "ThreeYearAgo";
    RelativeTimePeriodType[RelativeTimePeriodType["FourYearAgo"] = 10] = "FourYearAgo";
    RelativeTimePeriodType[RelativeTimePeriodType["FiveYearAgo"] = 11] = "FiveYearAgo";
    RelativeTimePeriodType[RelativeTimePeriodType["On2007Q4"] = 12] = "On2007Q4";
    RelativeTimePeriodType[RelativeTimePeriodType["On2008Q4"] = 13] = "On2008Q4";
    RelativeTimePeriodType[RelativeTimePeriodType["SchoolYrCurrent"] = 14] = "SchoolYrCurrent";
    RelativeTimePeriodType[RelativeTimePeriodType["SchoolYrLag1"] = 15] = "SchoolYrLag1";
    RelativeTimePeriodType[RelativeTimePeriodType["SchoolYrLag2"] = 16] = "SchoolYrLag2";
    RelativeTimePeriodType[RelativeTimePeriodType["SchoolYrLag3"] = 17] = "SchoolYrLag3";
    RelativeTimePeriodType[RelativeTimePeriodType["SchoolYrLag4"] = 18] = "SchoolYrLag4";
    RelativeTimePeriodType[RelativeTimePeriodType["SchoolYrLag5"] = 19] = "SchoolYrLag5";
    RelativeTimePeriodType[RelativeTimePeriodType["CurrentMonthEnd"] = 20] = "CurrentMonthEnd";
})(RelativeTimePeriodType || (RelativeTimePeriodType = {}));
export { Models };
